/** 根据当前domRef或者classname返回当前元素宽度 */
import { useState, useEffect } from 'react';
import { getImageWidth } from '@utils/imageLoad';

const useImageLoadHooks = (domRef?: any, imgWidth?: number) => {
  const [domWidth, setWidth] = useState(0);
  useEffect(() => {
    let width = imgWidth || 0;
    if (!imgWidth) {
      width = getImageWidth(domRef);
    }
    setWidth(width);
  }, [domRef, imgWidth]);
  return {
    domWidth,
  };
};
export default useImageLoadHooks;
